
export const common = {
  // Navigation
  home: "Home",
  features: "Features",
  cases: "Case Studies", 
  pricing: "Pricing",
  about: "About Us",
  getStarted: "Get Started",
  language: "English",

  // Common Actions
  contactUs: 'Contact Us',
  viewFaq: "View FAQ",

  // Hero Section
  heroSubtitle: "Flidge: Premium Game Localization, Perfected",
  heroTitle1: "So Players Around the World Can",
  heroTitle2: "Truly Understand Your Game",
  heroDescription: "Leveraging advanced AI technology to provide developers with accurate, fast, and cost-effective multilingual translation solutions—empowering you to fully expand into global player markets and seize new opportunities.",
  learnMore: "Learn More",
  freeTrial: "Free Trial",
  socialProof: "The Trusted Choice of 80+ Game Developers and Publishers",
  
  // Features Section
  featuresSubtitle: "Core Advantages",
  featuresTitle: "Efficient Game Localization Solutions",
  
  feature1Title: "Fast & Efficient Delivery",
  feature1Description: "Deliver accurate, high-quality translations in shorter timeframes—completing 200,000 characters within 1 day. Dramatically improve localization efficiency for game projects. Compared to traditional human translation, significantly reduce human error with precise recognition of capitalization and punctuation differences. Translation quality certified by professional translation agencies.",
  
  feature2Title: "Multi-language & Multi-scenario Support", 
  feature2Description: "We offer translation services in 64 languages worldwide, supporting diverse content scenarios including game dialogue and narratives, store pages, game titles, glossaries, official websites, and more—comprehensively meeting all your localization needs.",

  // Feature 2 Additional
  glossary: "Glossary",
  gameTermsReference: "Game Terminology Reference",
  storePage: "Store Page",
  storePageDesc: "Game title, game description, key features, tagline",
  gameStoryTranslation: "Game Story Translation",
  gameStoryDesc: "Main quest storylines, side quests",
  completed: "Completed",
  inProgress: "In Progress",
  pending: "Pending",

  feature3Title: "Multiple Format Support",
  feature3Description: "Support for multiple text formats for import and export, enabling seamless integration of translated content into your game projects. Compatible with any game engine for efficient implementation.",
  
  feature4Title: "Game-Savvy Localization Services",
  feature4Description: "Specialized in game localization with deep understanding of game copy, dialogue, UI, and other scenario-specific content requirements. Equipped with extensive gaming terminology databases to ensure authentic localized expressions that resonate with players and enhance their understanding of your game.",
  
  // Feature 4 Additional
  professionalGlossary: "Professional Terminology Database",
  professionalTerminologyDatabase: "Professional Terminology Database",
  cheese: "Cheese",
  feeding: "Feeding",
  rush: "Rush",
  balance: "Balance",
  fightingGamesJapanese: "Fighting games - Japanese",
  mobaGamesKorean: "MOBA games - Korean",
  starcraftRussian: "StarCraft - Russian",
  actionGamesChinese: "Action games - Chinese",
  more: "More",
  
  // Features Section Additional
  translationTimeComparison: "Translation Time Comparison",
  basedOnProject: "Based on a 200,000-character project",
  traditionalAgency: "Traditional Translation Agency",
  aiPlatform: "Flidge AI Translation Service",
  days: " days",
  day: " day",
  hours: " hours",
  hour: " hour",
  "10days": "10 days",
  "1day": "1 day",
  "240hours": "240 hours", 
  "24hours": "24 hours",

  // Case Studies Section
  casesSubtitle: "Case Studies",
  casesTitle: "Helping Indie Games Find Their Global Audience",
  casesDescription: "We treasure every opportunity to collaborate, and our mission is to help more indie games reach players around the world",
  
  // Game Types
  platformActionGame: "Platform Action Game",
  musicRhythmGame: "Rhythm Game",
  actionStealthGame: "Action Stealth Game",
  casualPuzzleGame: "Casual Puzzle Game",
  roguelikeCardGame: "Simulation Management Game",
  simulationGame: "Simulation Management Game",
  
  // Game Descriptions
  haakDescription: "Provided support for 14 languages for the Metroidvania game HAAK, resulting in a 147% increase in monthly sales",
  museDashDescription: "Provided Japanese, Korean, and English translation support for the rhythm game Muse Dash, delivering high-quality localized content to hundreds of millions of players worldwide",
  kristalaDescription: "Provided Chinese, Korean, Arabic, German, Spanish translation support for the action stealth game Kristala, including game title and store page localization",
  lazyMeowDescription: "Provided localization support in English, Japanese, and Korean for the casual puzzle game Lazy Meow City, helping the game break into the Asia-Pacific market",
  stoneSquadDescription: "Provided support for Cooking Go in 12 languages including English, Japanese, Korean, French, and Spanish",
  catHotelDescription: "Provided English, Japanese, Simplified Chinese, and Traditional Chinese translation services for CatHotel's storylines, quests, items, and store pages, ensuring a more localized gaming experience",
  
  // Results
  monthlyRevenueGrowth: "147% monthly revenue growth",
  playerReviews: "Positive player reviews",
  translationCompleted: "Translation completed",
  salesIncrease: "Sales increase",
  exposureGrowth: "Exposure growth",
  playerReviews2: "Positive player reviews",
  result: "Result",
  customerReviews: 'Customer Reviews',
  realUserFeedback: 'Real User Feedback',
  
  // Pricing Section
  pricingSubtitle: "Service Pricing",
  pricingTitle: "Transparent Pricing Plans",
  pricingDescription: "We offer flexible pricing plans to meet the needs of projects of all sizes. Every partner entity can enjoy a free trial quota.",
  
  freeTrialTitle: "Free Trial Quota",
  standardPricing: "Standard Pricing",
  standardPricingDescription: "Standard rates apply after free quota",
  standardPricingFeatures: {
    languages: "Translation support for 64 languages",
    speed: "Translate up to 200,000 characters within 24 hours",
    formats: "Multiple file format support",
    glossary: "Professional gaming terminology database",
    quality: "Quality assurance and revision services"
  },
  customPrice: "Custom",
  customPlan: "Pricing Plans",
  customPlanDescription: "Exclusive pricing for large projects",
  
  // Enterprise Features
  enterpriseCustom: "Enterprise Custom",
  recommended: "Recommended",
  perCharacter: "Per Character",
  perLanguage: "Per Language",
  startUsing: "Get Started",
  contactBusinessTeam: "Contact Sales Team",
  
  enterpriseFeatures: {
    allStandard: "Includes all standard features",
    manager: "Dedicated account manager service",
    priority: "Priority processing and expedited service",
    customGlossary: "Custom glossaries and style guide",
    discount: "Volume discounts and long-term partnership benefits",
    extraTrial: "Additional free trial quota available"
  },

  // Pricing Section Additional
  languagesCount: "Languages",
  freeExperience: "Free Experience", 
  freeTrialDescription: "Each partner entity can receive a free trial quota of 5,000 characters for translation into one language of your choice, so you can fully experience our translation quality",
  
  // New Pricing Calculator Section
  priceCalculator: "Price Calculator",
  calculatorDescription: "Get instant cost estimates for your projects",
  charactersCount: "Character Count",
  targetLanguagesCount: "Target Languages Count",
  estimatedCost: "Estimated Cost",
  
  calculationNotes: "How we calculate",
  calculationDetails: {
    freeQuota: "Each cooperation entity enjoys 5000 characters free quota (limited to one language)",
    pricing: "Charges beyond free quota at $0.011/character/language",
    bulkDiscount: "Large volume projects can enjoy enterprise custom pricing",
    finalPrice: "Final price is subject to business team quotation"
  },

  // About Section
  aboutSubtitle: "About Us",
  aboutTitle: "Professional Game Localization Service Team",
  aboutDescription: "Founded in 2019, Flidge is a technology company specializing in game localization. We combine AI technology with professional human review to provide high-quality, efficient multilingual localization services for game developers worldwide, helping exceptional games reach global audiences.",
  
  ourMission: "Our Mission",
  ourVision: "Our Vision",
  missionText: "Through advanced AI technology and professional localization services, we break down language barriers, enabling every exceptional game to succeed in global markets and allowing players worldwide to enjoy remarkable gaming experiences.",
  visionText: "To become the world's leading game localization service platform, contributing to the global expansion of the gaming industry through technological innovation and professional services, spreading excellent gaming culture across the world.",
  
  // FAQ Section
  faqSubtitle: 'Frequently Asked Questions',
  faqTitle: 'FAQ',
  faqDescription: 'If you have any further questions, please feel free to contact us anytime',
  stillHaveQuestions: "Have Questions?",
  
  faqQuestion1: 'Do you offer trial translation quota?',
  faqQuestion2: 'At what stage of game development is it recommended to start using Flidge\'s services?',
  faqQuestion3: 'What if my game project doesn\'t have a glossary?',
  faqQuestion4: 'Will my game content be kept strictly confidential?',
  
  // FAQ Items
  faq1Question: "Do you offer trial translation quota?",
  faq1Answer: "We offer each partner a free trial of 5,000 characters for translation into one target language. Additional characters are charged at $0.016 per character per target language. For extended trial quotas, please contact our business team.",
  
  faq2Question: "At what stage of game development should I start using Flidge's services?",
  faq2Answer: "We recommend using Flidge's services during the mid-to-late stages of your game development cycle. This timing helps minimize your localization costs while allowing us to provide store page translation support and help you select localized game titles that resonate better with players, making your game more memorable and helping you expand into global markets. If your game is about to launch on Steam or other gaming platforms, Flidge's services are perfect for you. We can complete extensive localization work across multiple languages in a very short timeframe, helping players worldwide discover your game.",
  
  faq3Question: "What if my game project doesn't have a glossary?",
  faq3Answer: "We can provide glossary management services through Flidge AI to help you better manage your projects and translation content. We'll work with you to confirm and verify terminology usage, ensuring these terms are used consistently throughout your game. If you need glossary management services, please feel free to contact us anytime.",
  
  faq4Question: "Will my game content be kept strictly confidential?",
  faq4Answer: "We employ industry-standard encryption and compartmentalized workflows specifically designed for game projects. Every team member operates under strict NDAs with clear financial liability. Our development environment ensures complete asset isolation—no screenshots, no external drives, no personal devices. We understand that leaked gameplay footage, story elements, or release dates can devastate a game's market impact—your creative IP receives the same protection we demand for our own unpublished titles.",
  
  // CTA Section
  ctaTitle1: "Make the world",
  ctaTitle2: "love your game",

  // Contact Section
  contactSubtitle: "Contact Us",
  contactTitle: "Get Professional Translation Services and Free Trial",
  contactDescription: "Complete the form below, and our team will provide a detailed service proposal within 24 hours",
  
  name: "Name",
  email: "Email",
  company: "Company/Studio Name",
  targetLanguages: "Target Languages",
  projectDetails: "Project Details",
  getQuote: "Get a Quote",
  onlineConsult: "Online Consultation",
  emailContact: "Email Contact",
  
  // Footer
  footerDescription: "We provide indie games with efficient, accessible, and cost-effective localization services, helping projects achieve global growth through intelligent translation, analysis, and personalized language solutions.",
  services: "Services",
  companySection: "About",
  resources: "Resources",
  featuresLink: "Features",
  pricingConsult: "Pricing",
  aboutUs: "About Us",
  helpCenter: "Help Center",
  techBlog: "Tech Blog",
  termsOfService: "Terms of Service",
  privacyPolicy: "Privacy Policy",
  cookiePolicy: "Cookie Policy",
  poweredBy: "Powered by Readdy",
  copyright: "© 2026 Shenzhen Giant Core Limited. All rights reserved.",
  
  // Form labels
  required: "*",
  characterCount: "characters",
  
  // Form placeholders
  namePlaceholder: "Please enter your name",
  emailPlaceholder: "Please enter your email address",
  companyPlaceholder: "Please enter company or studio name",
  languagesPlaceholder: "e.g.: English, Japanese, Korean, etc.",
  messagePlaceholder: "Please describe your project requirements in detail, including game type, translation content, special requirements, etc...",
  
  // Alt texts
  gameIcon: "Game Icon",
  flidgeLogo: "Flidge Logo",
  abstractShape: "Abstract Shape",
  
  // Testimonials
  testimonialSarahRole: "Independent Game Developer",
  testimonialSarahContent: "After adopting Flidge, our game has received an excellent response in overseas markets. The translation quality far exceeded our expectations—players say the narrative feels authentic, with none of the awkwardness of machine translation.",
  
  testimonialThijsRole: "Game Studio Director",
  testimonialThijsContent: "From initial script translation to later copy optimization, the Flidge team demonstrated exceptional professionalism throughout. Their understanding of gaming culture made the localization process seamless.",
  
  testimonialEmmaRole: "Game Localization Manager",
  testimonialEmmaContent: "Flidge's translation services saved us tremendous time and costs. Their AI technology is not only fast but also accurately handles the specialized terminology and cultural nuances within our game.",
  
  testimonialDavidRole: "Game Producer",
  testimonialDavidContent: "Our game achieved tremendous success in the Japanese and Korean markets, thanks to the quality localization services provided by Flidge. Their deep understanding of East Asian culture made the translations authentic.",
  
  testimonialAlexRole: "Independent Developer",
  testimonialAlexContent: "As a small team, localization costs were our biggest concern. Flidge is not only reasonably priced but also highly efficient, enabling us to enter multiple overseas markets simultaneously.",
  
  testimonialYukiRole: "Producer",
  testimonialYukiContent: "I'm impressed by Flidge's understanding of Japanese gaming culture. They didn't just translate the words—they conveyed the game's core spirit, allowing overseas players to experience the game's true essence.",
  
  abstractShape2: "Abstract Shape 2",

  // New entries from modification
  partners: "Partners",
  trustedPartners: "Trusted Partners",
  partnersDescription: "Building long-term partnerships with leading game studios and enterprises worldwide",

  gameProjectsServed: "Companies Served",
  supportedLanguages: "Supported Languages",
  clientSatisfaction: "Client Satisfaction",
  responseTime: "Response Time",

  // Additional Metrics
  translatedCharactersCount: "5M+",
  avgTranslationSpeedValue: "3.2 seconds",
  translatedCharacters: "Characters Translated",
  avgTranslationSpeed: "Average Translation Time per 1,000 Words",
  clientSatisfactionRate: "Client Satisfaction Rate",
  servicedCompanies: "Companies Served",
  successMetrics: "Success Metrics",
  serviceImpact: "Service Impact",

  // Statistics
  stat1Number: '80+',
  stat1Label: 'Companies Served',
  stat2Number: '64',
  stat2Label: 'Supported Languages',
  stat3Number: '97%',
  stat3Label: 'Client Satisfaction',
  stat4Number: '24h',
  stat4Label: 'Response Time',

  // Terms of Service
  termsTitle: 'Terms of Service',
  termsLastUpdated: 'Last updated: January 2025',
  terms1Title: '1. Acceptance of Terms',
  terms1Content: 'By accessing and using Flidge AI Translation Services, you accept and agree to be bound by the terms and provision of this agreement.',
  terms2Title: '2. Use License',
  terms2Content: 'Permission is granted to temporarily download one copy of the materials on Flidge\'s website for personal, non-commercial transitory viewing only.',
  terms3Title: '3. Disclaimer',
  terms3Content: 'The materials on Flidge\'s website are provided on an \'as is\' basis. Flidge makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.',
  terms4Title: '4. Limitations',
  terms4Content: 'In no event shall Flidge or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Flidge\'s website.',
  terms5Title: '5. Accuracy of Materials',
  terms5Content: 'The materials appearing on Flidge\'s website could include technical, typographical, or photographic errors. Flidge does not warrant that any of the materials on its website are accurate, complete, or current.',
  terms6Title: '6. Links',
  terms6Content: 'Flidge has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site.',
  terms7Title: '7. Modifications',
  terms7Content: 'Flidge may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.',
  terms8Title: '8. Governing Law',
  terms8Content: 'These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts.',

  // Privacy Policy
  privacyTitle: 'Privacy Policy',
  privacyLastUpdated: 'Last updated: January 2025',
  privacy1Title: '1. Information We Collect',
  privacy1Content: 'We collect information you provide directly to us, such as when you create an account, use our translation services, or contact us for support. This may include your name, email address, company information, and content you submit for translation.',
  privacy2Title: '2. How We Use Your Information',
  privacy2Content: 'We use the information we collect to provide, maintain, and improve our translation services, process transactions, send technical notices and support messages, respond to your comments and questions, and monitor usage patterns.',
  privacy3Title: '3. Information Sharing',
  privacy3Content: 'We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy. We may share information with trusted service providers who assist us in operating our services.',
  privacy4Title: '4. Data Security',
  privacy4Content: 'We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.',
  privacy5Title: '5. Data Retention',
  privacy5Content: 'We retain your personal information for as long as necessary to provide our services and fulfill the purposes outlined in this policy, unless a longer retention period is required by law.',
  privacy6Title: '6. Your Rights',
  privacy6Content: 'You have the right to access and update your personal information, request deletion of your personal data, object to processing, request data portability, and withdraw consent where applicable.',
  privacy7Title: '7. Cookies and Tracking',
  privacy7Content: 'We use cookies and similar tracking technologies to enhance your experience on our website. You can control cookie settings through your browser preferences. For more details, please see our Cookie Policy.',
  privacy8Title: '8. International Transfers',
  privacy8Content: 'Your information may be transferred to and processed in countries other than your own. We ensure appropriate safeguards are in place to protect your personal information in accordance with applicable data protection laws.',
  privacy9Title: '9. Changes to This Policy',
  privacy9Content: 'We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on this page and updating the "Last updated" date.',
  privacy10Title: '10. Contact Us',
  privacy10Content: 'If you have any questions about this Privacy Policy, please contact us at privacy@flidge.ai or through our contact form.',

  // Cookie Policy
  cookieTitle: 'Cookie Policy',
  cookieLastUpdated: 'Last updated: January 2025',
  cookie1Title: '1. What Are Cookies',
  cookie1Content: 'Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our services.',
  cookie2Title: '2. Types of Cookies We Use',
  cookie2Content: 'We use essential cookies for basic website functionality, performance cookies to analyze usage patterns, and functional cookies to remember your preferences and provide enhanced features.',
  cookie2Essential: 'Essential Cookies',
  cookie2EssentialDesc: 'These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.',
  cookie2Performance: 'Performance Cookies',
  cookie2PerformanceDesc: 'These cookies collect information about how visitors use our website, such as which pages are visited most often. This data helps us improve our website performance.',
  cookie2Functional: 'Functional Cookies',
  cookie2FunctionalDesc: 'These cookies allow the website to remember choices you make and provide enhanced, more personal features.',
  cookie3Title: '3. Third-Party Cookies',
  cookie3Content: 'We may use third-party services that place cookies on your device. These include analytics services, social media platforms, and advertising networks. Each third party has their own privacy and cookie policies.',
  cookie4Title: '4. Managing Cookies',
  cookie4Content: 'You can control and manage cookies through browser settings, delete existing cookies, set notifications for when cookies are sent, or use private browsing mode.',
  cookie5Title: '5. Cookie Consent',
  cookie5Content: 'By continuing to use our website, you consent to our use of cookies as described in this policy. You can withdraw your consent at any time by adjusting your browser settings or contacting us.',
  cookie6Title: '6. Impact of Disabling Cookies',
  cookie6Content: 'If you choose to disable cookies, some features of our website may not function properly. This could affect your user experience and limit access to certain services.',
  cookie7Title: '7. Updates to This Policy',
  cookie7Content: 'We may update this Cookie Policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons. Please check this page periodically for updates.',
  cookie8Title: '8. Contact Information',
  cookie8Content: 'If you have any questions about our use of cookies, please contact us at cookies@flidge.ai or through our contact form.'
};

export default common;
